import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { TcsmAppConfigs } from '../../../../../global/models/configuration-models';
import { ArcRoutes } from '../../../constants/routes';
import { NewHireApp } from '../../new-hire/new-hire-app';
import EmployeeInfoCompRecordWrapper from './employee-info-comp-record-wrapper';
import { AnnualEnrollmentContext, AnnualEnrollmentKey } from '../../../../annual-enrollment/models/annual-enrollment-models';


interface Props {
	appSettings: TcsmAppConfigs;
	successRedirectOverwrite: string;
}

function EmploymentRecord(props: Props) {

	const { appSettings, successRedirectOverwrite } = props;
	const routeMatch = useRouteMatch();


	return (
		<AnnualEnrollmentContext.Provider value={AnnualEnrollmentKey.newHireEnrollment}>
			<Switch>
				<Route exact path={`${routeMatch.path}${ArcRoutes.NonStipNewHire}`}
					render={() => (
						<NewHireApp
							settingsId={appSettings.newHireSettingsId}
							nonStip
							succesRedirectOverwrite={successRedirectOverwrite}
						/>

					)}
				/>
				<Route exact path={`${routeMatch.path}${ArcRoutes.StipNewHire}`}
					render={() => (
						<NewHireApp
							settingsId={appSettings.newHireSettingsId}
							nonStip={false}
							succesRedirectOverwrite={successRedirectOverwrite}
						/>
					)}
				/>
				<Route path={`${routeMatch.path}`}
					render={() => (
						<EmployeeInfoCompRecordWrapper appSettings={appSettings} />
					)}
				/>
			</Switch>
		</AnnualEnrollmentContext.Provider>
	);
}

export default EmploymentRecord;